import { render, staticRenderFns } from "./standart-category-dd.vue?vue&type=template&id=5a0b1416&"
import script from "./standart-category-dd.vue?vue&type=script&lang=ts&"
export * from "./standart-category-dd.vue?vue&type=script&lang=ts&"
import style0 from "./standart-category-dd.vue?vue&type=style&index=0&id=5a0b1416&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports